import React from 'react';
import { LuBuilding2, LuFactory, LuGlobe, LuTrendingUp } from 'react-icons/lu';
import SafeIcon from '../../common/SafeIcon';

const AccountStats = ({ accounts }) => {
  const totalAccounts = accounts.length;
  const uniqueIndustries = new Set(accounts.map(a => a.industry).filter(Boolean)).size;
  const uniqueCountries = new Set(accounts.map(a => a.country).filter(Boolean)).size;
  const recentAccounts = accounts.filter(a => {
    const createdDate = new Date(a.created_at);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    return createdDate >= thirtyDaysAgo;
  }).length;

  const stats = [
    {
      label: 'Total Accounts',
      value: totalAccounts,
      icon: LuBuilding2,
      color: 'blue'
    },
    {
      label: 'Industries',
      value: uniqueIndustries,
      icon: LuFactory,
      color: 'purple'
    },
    {
      label: 'Countries',
      value: uniqueCountries,
      icon: LuGlobe,
      color: 'green'
    },
    {
      label: 'New (30 days)',
      value: recentAccounts,
      icon: LuTrendingUp,
      color: 'yellow'
    }
  ];

  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    purple: 'bg-purple-100 text-purple-600',
    green: 'bg-green-100 text-green-600',
    yellow: 'bg-yellow-100 text-yellow-600'
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-600">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{stat.value}</p>
            </div>
            <div className={`h-12 w-12 rounded-lg flex items-center justify-center ${colorClasses[stat.color]}`}>
              <SafeIcon icon={stat.icon} className="h-6 w-6" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AccountStats;